module.exports = __webpack_public_path__ + "static/media/login.9873823d.png";